
class CPUTest {

	constructor ( options ) {

        // limit in ms to test CPUs
        this.limit = options?.limit || 8;
        this.log = options?.log || false;
		this.callback = options?.callback;

		// properties
		window.hasGoodCPU = false;
		this.time = 10000;
		
		// browser capacity check
		if (!window.Worker || typeof window.Worker === "undefined") {
		 	console.warn('CPUTest: Web workers are not available.');

		 	return;
		}

		// options

		// binding
		this.bindOnMessage = this.onMessage.bind(this);	
		this.bindOnError = this.onError.bind(this);	

		// worker
		this.worker = new Worker('/assets/scripts/worker.js');
		this.worker.addEventListener("message", this.bindOnMessage);
        this.worker.addEventListener("error", this.bindOnError);
    }

	/**
	 * Test run
	 */
	run() {        
		// security check
		if(!this.worker) return;

		this.worker.postMessage({
			id: Date.now(),
			message: { fn: 'calculate' }
		});
	}

	/**
	 * Error handling
	 */
	onError( error ) {
		console.error('CPUTest :: Error:', error);

		this.callback?.();
	}

	/**
	 * Test done
	 */
	onMessage(e) {

		if(e) this.time = e.data.message.time;

		window.hasGoodCPU = this.time < this.limit;
        console.log('onMessage')

		if(this.log){
			this.logReport();
		}

		this.callback?.(this.time);
		
		this.destroy();
	}

	/**
	 * Report
	 */
	logReport() {
        console.log('%cCPU report','background-color:#ff0000; padding:0px 10px; color:#fff;');

        if(window.hasGoodCPU) {
            console.log(`%cCPU status: GOOD 🤘(${this.time}ms)`,'color:#fff;background-color: #64c845');
        } else {
            console.log(`%cCPU status: BAD 😅(${this.time}ms)`,'color:#fff;background-color: #ff0000');

        }
	}


	/**
	 * Dispose
	 */
	destroy() {	

		this.worker.removeEventListener("message", this.bindOnMessage);
		this.worker.removeEventListener("error", this.bindOnError);
  		this.worker.terminate();

		this.worker = null;
		this.callback = null;
		this.onMessage = null;
		this.onError = null;
  	}
}

export default CPUTest;
